import Avatar from 'assets/image/avatar.png';
import BG1 from 'assets/image/bg-1.jpg';
import BG2 from 'assets/image/bg-2.jpg';
import BG3 from 'assets/image/bg-3.jpg';
import BG4 from 'assets/image/bg-4.jpg';
import BG5 from 'assets/image/bg-5.jpg';
import BG6 from 'assets/image/bg-6.jpg';
import BG7 from 'assets/image/bg-7.jpg';
import BG8 from 'assets/image/bg-8.jpg';
import BG9 from 'assets/image/bg-9.jpg';

import CARD1 from 'assets/image/card-1.png';
import CARD2 from 'assets/image/card-2.png';
import CARD3 from 'assets/image/card-3.png';

import MARK from 'assets/image/mark.jpg';
import SEAL_YELLOW from 'assets/image/seal-yellow.png';

import FRONTEND from 'assets/image/frontend.png';
import BACKEND from 'assets/image/backend.png';

import DARK from 'assets/image/dark.jpg';
import BRIGHT from 'assets/image/bright.jpg';

import ASUNA from 'assets/image/asuna.jpg';
import CERASHEALTH from 'assets/image/cerashealth.png';
import SPORTSBLOG from 'assets/image/sportsblog.png';
import PICKADE from 'assets/image/pickade.png';
import CBET from 'assets/image/cbet.png';
import RAFFLE from 'assets/image/raffle.png';
import MAPBOX from 'assets/image/mapbox.png';
import BLOXMOON from 'assets/image/bloxmoon.png';
import AMINOREWARDS from 'assets/image/aminorewards.png';
import ARMORY from 'assets/image/armory.png';
import BANNER from 'assets/image/banner.png';

//Frontend and Backend images
import NUSET from 'assets/image/nuset.png';
import SHISEIDO from 'assets/image/shiseido.png';
import KAHOU from 'assets/image/kahou.png';
import YS_DENTAL_CLINIC from 'assets/image/ys_dental_clinic.png';
import MARIMO_CRAFT from 'assets/image/marimo_craft.png';
import HAMAOKA_MEKKI from 'assets/image/hamaoka_mekki.png';
import HARUCHIKA_INSTRUMENTS from 'assets/image/haruchika_instruments.png';
import REWRITE_SERVICE from 'assets/image/rewrite_service.png';
import SUNNY_SEALING from 'assets/image/sunny_sealing.png';

import SHOKUBUN from 'assets/image/shokubun.png';
import FREE_LOCATION from 'assets/image/free_location.png';
import PRO_D_USE from 'assets/image/pro_d_use.png';
import MSOLS from 'assets/image/msols.png';
import RECRUIT_MS from 'assets/image/recruit_ms.png';
import CAREER_SCOUT from 'assets/image/career_scout.png';
import NEXT_LEVEL_HOLDINGS from 'assets/image/next_level_holdings.png';
import MEDENTO from 'assets/image/medento.png';
import GIVERY from 'assets/image/givery.png';

const constantImages = {
    Avatar,
    BG1,
    BG2,
    BG3,
    BG4,
    BG5,
    BG6,
    BG7,
    BG8,
    BG9,
    FRONTEND,
    BACKEND,
    MARK,
    SEAL_YELLOW,
    DARK,
    BRIGHT,
    CARD1,
    CARD2,
    CARD3,
    ASUNA,
    CERASHEALTH,
    SPORTSBLOG,
    PICKADE,
    CBET,
    RAFFLE,
    MAPBOX,
    BLOXMOON,
    AMINOREWARDS,
    ARMORY,
    BANNER,
    NUSET,
    SHISEIDO,
    KAHOU,
    YS_DENTAL_CLINIC,
    MARIMO_CRAFT,
    HAMAOKA_MEKKI,
    HARUCHIKA_INSTRUMENTS,
    REWRITE_SERVICE,
    SUNNY_SEALING,
    SHOKUBUN,
    FREE_LOCATION,
    PRO_D_USE,
    MSOLS,
    RECRUIT_MS,
    CAREER_SCOUT,
    NEXT_LEVEL_HOLDINGS,
    MEDENTO,
    GIVERY
}

export default constantImages;